"use client";
import styles from "./home.module.css";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
// import posthog from "posthog-js";

export default function HeroSection() {
  const t = useTranslations("home");
  return (
    <section className={styles.heroSection}>
      <div className="container-md">
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{t("heroTitle")}</h1>
          <p className={styles.heroSubtitle}>{t("heroSubtitle")}</p>
          <div className={styles.heroDescription}>
            <p>{t("heroDesc1")}</p>
            <p>{t("heroDesc2")}</p>
            <p>{t("heroDesc3")}</p>
            <p>{t("heroDesc4")}</p>
          </div>
          <div className={styles.heroCTA}>
            <Link
              href="#calculator-tools"
              className={styles.ctaButton}
              // onClick={() => posthog.capture('hero_cta_clicked', { cta_label: 'explore_tools' })}
            >
              {t("exploreTools")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
